import Vue from 'vue'
//import axios from 'axios'
//import VueAxios from 'vue-axios'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import App from '~/components/App'
import '~/plugins'
import '~/components'
import Crud from './components/Crud'

Vue.config.productionTip = false

/* eslint-disable no-new */
/*let vm = */new Vue({
  i18n,
  store,
  router,
  ...App
})

// window.vm = vm;


// WEBPACK FOOTER //
// ./resources/js/app.js